module.exports = __webpack_public_path__ + "img/country4.aac2c5f4.jpg";